import {MomentInput} from 'moment';
import getMinDate from '../../../utils/getMinDate';
import {MomentDate} from '../CreateRecommend/recommendFields';

export const getWithdrawalMinimumDate = (today: MomentInput, dateValue?: MomentDate) => {
  const minimumDate = getMinDate({
    today,
    dateValue,
    daysOffset: 10,
    isBusiness: true,
  });
  if (minimumDate.date() === 1 || minimumDate.date() === 15) {
    // do nothing
  } else if (minimumDate.date() < 15) {
    minimumDate.set('date', 15);
  } else {
    minimumDate.add(1, 'month');
    minimumDate.startOf('month');
  }
  return minimumDate;
};
